import FinnmarkskommisjonenPageData from 'Models/Content/FinnmarkskommisjonenPageData';
import { ThemePageType } from './ThemePageType';
import IContent from '@episerver/spa-core/dist/Models/IContent';
import { BannerInfo, emptyBannerInfo } from 'app/Models/Interfaces/Banner/BannerInfo';
import EnkeltDomstolPageData from 'app/Models/EnkeltDomstolPageData';

export function getClassifiedBannerType(currentAncestor: IContent): BannerInfo {
    const breadcrumbMarginTopEl = document.getElementsByClassName('breadcrumb-margin');

    if (breadcrumbMarginTopEl != null && breadcrumbMarginTopEl.length > 0) {
        breadcrumbMarginTopEl[0].classList.add('banner');
    }

    if (currentAncestor.contentType.includes('EnkeltDomstolPage')) {
        const enkeltDomstolPage = currentAncestor as EnkeltDomstolPageData;
        return {
            bannerName: enkeltDomstolPage?.name.toString(),
            bannerType: ThemePageType.EnkeltDomstol,
            mainPageLink: enkeltDomstolPage?.url,
            domstolType: enkeltDomstolPage?.domstolType?.value,
        };
    }

    if (currentAncestor.contentType.includes('FinnmarkskommisjonenPage')) {
        const page = currentAncestor as FinnmarkskommisjonenPageData;

        return {
            bannerName: page?.name.toString(),
            bannerType: page?.themePageType?.value,
            mainPageLink: page?.url,
        };
    }

    return emptyBannerInfo;
}
